// The persisted external reference is issued once by the prescription writer.
// Legacy records may carry that same reference in meta; never mint a display ID.
export function prescriptionIdentifier(row = {}) {
  return String(row.external_rx_id || row.meta?.rxNo || row.rxNo || row.id || '').trim();
}
